import { gql } from '@apollo/client';

const GET_METRIC_INFO = gql`
  query GetMetricInfo($metricId: Int!, $checkPointId: Int!, $appraisalId: Int!) {
    performanceMetric(metricId: $metricId, checkPointId: $checkPointId, appraisalId: $appraisalId) {
      Id
      CheckpointPerformanceItemDataPoints {
        Id
        Status
        LowerLimit
        UpperLimit
        Actual
        Notes
        CheckpointPerformanceItems {
          Id
          MeasurementName
          MeasurementDescription
          MeasurementCalculation
          MeasurementUnit
          Numerator
          Denominator
          TargetDescription
          GoodPerformanceIndicator
          TimeBounds
          TimeFrame
          CaptureFrequency
          ReportFrequency
          MeasurementLevel
          MeasurementUse
          LimitationsOrBlindSpots
          QualityDomain
          CustomQualityDomainDefinition
          BusinessObjective
          QualityObjective
          IsDiscontinued
          DiscontinuedReason
        }
      }
    }
  }
`;

export default GET_METRIC_INFO;
